import type {} from '@angular/localize/init';
import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { appRoutesI18nCache } from '../i18n-cache';

export function slotsRouteI18n(config?: TranslationConfig): string {
  if (config?.translateForLang && globalThis.$localizeForLang) {
    return globalThis.$localizeForLang`:url-segment@@slots-url-segment:slots`;
  }
  return (appRoutesI18nCache['slots'] ??= $localize`:url-segment@@slots-url-segment:slots`);
}
